export default __webpack_public_path__ + "static/media/Add templates for Journal.89a865df.mp4";